var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanceledStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 1.92C6.442 1.92 1.92 6.442 1.92 12S6.442 22.08 12 22.08 22.08 17.558 22.08 12 17.558 1.92 12 1.92zm4.56 8.88c.663 0 1.2.537 1.2 1.2 0 .663-.537 1.2-1.2 1.2H7.44c-.663 0-1.2-.537-1.2-1.2 0-.663.537-1.2 1.2-1.2z",
    transform: "translate(-1262.000000, -207.000000) translate(462.000000, 10.000000) translate(0.000000, 95.000000) translate(0.000000, 64.000000) translate(780.000000, 32.000000) translate(20.000000, 6.000000)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceledStatus);
export default __webpack_public_path__ + "static/media/canceled-status.6c56da78.svg";
export { ForwardRef as ReactComponent };